import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { getPageTitle } from "../../utils/utilities";

const PageTitle = ({ title }: { title?: string }) => {
  const location = useLocation();
  const pageTitle = useMemo(() => getPageTitle(title), [location, title]);

  useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  return (
    <div
      aria-live="polite"
      aria-atomic="true"
      style={{
        position: "absolute",
        width: "1px",
        height: "1px",
        padding: 0,
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        border: 0
      }}>
      {pageTitle}
    </div>
  );
};

export default PageTitle;
